import classNames from "classnames";
import moment from "moment";
import React, { PropTypes } from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DownloadS3Button, MessageBox } from "../../../../common";

import _ from "lodash";
import { actions, formValueSelector, change as changeFieldValue } from "redux-form";
import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import LocaleUtils from "../../../../../utils/LocaleUtils";
import {
  PLAN_ADMINISTRATOR,
} from "../../../../../utils/Roles";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  ACTIVE_BILLING_PERIODS,
  BILLING_PERIODS,
  INVOICES_TABLE,
  INVOICE_ATTACHMENTS,
  INVOICE_DATA,
} from "../../../../../utils/data/models";
import userHasAccess from "../../../../../utils/userHasAccess";
import { DataTable } from "../../../../common/DataTable";
import { EN, FR } from "../../../../common/enums/languages";
import { renderErrorModal } from "../../../../common/form/FieldErrorHelper";
import { MANUAL, RECURRING } from "../../enums/billingPeriodTypes";
import { PM } from "../../enums/businessAccountTypes";
import InvoiceState from "./InvoiceState";
import InvoiceDataTableHeader from "./InvoicesDataTableHeader";
import {
  EXCEL,
  PDF,
  SUMMARY,
  SUMMARY_ONLY,
} from "./enums/invoiceAttachmentsType";
import {
  FAILURE,
  GENERATING,
} from "./enums/invoiceStatuses";
import { CREDITS, STANDARD, STANDARD_CREDITLESS } from "./enums/invoiceTypes";
import {
  LONG_PDF,
  PREMIUM_BY_INSURER,
  SHORT_EXCEL,
  SHORT_PDF,
  SUMMARY_EXCEL,
} from "./enums/invoiceViewTypes";
import * as invoiceActions from "./invoiceActions";

const LIMIT_INVOICES_DISPLAYED = 6;
const LIMIT_INVOICES_DISPLAYED_MANUAL = 10000;

class InvoicesDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      invoiceId: null,
      latestGeneratedPeriod: null,
      languageCode: null,
      filters: props.filters,
      isValid: true,
      invoiceAttachmentId: 0,
      objectPath: null,
      objectName: null,
      fetching: true,
      showModal: false,
      errorsString: null,
      errorPath: "validation/clientFieldValidation/serverErrors",
      isDisabled: false,
      chosenBillingPeriodFilter: null,
      limitInvoiceDisplayed: props.client.clientBillingPeriodType == MANUAL.value ? LIMIT_INVOICES_DISPLAYED_MANUAL : LIMIT_INVOICES_DISPLAYED
    };
    this.setCellClassNames = this.setCellClassNames.bind(this);
    this.setPlanAdministratorCSS = this.setPlanAdministratorCSS.bind(this);
    this.invoiceStatusCSS = this.invoiceStatusCSS.bind(this);
    this.getData = this.getData.bind(this);
    this.refreshDataTable = this.refreshDataTable.bind(this);
    this.handleCloseForm = this.handleCloseForm.bind(this);
    this.updateBillingPeriodFilter = this.updateBillingPeriodFilter.bind(this);
    this.onDownloaded = this.onDownloaded.bind(this);
    this.setLanguageCode = this.setLanguageCode.bind(this);
    this.monthMinusX = this.monthMinusX.bind(this);
    this.buildDescription = this.buildDescription.bind(this);
    this.canDownload = this.canDownload.bind(this);
    this.updateValidity = this.updateValidity.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getColsForManualClients = this.getColsForManualClients.bind(this);
    this.getColsForRecurringClients = this.getColsForRecurringClients.bind(this);
    this.getBillingPeriodFilterDefaultValue = this.getBillingPeriodFilterDefaultValue.bind(this);
    this.fetchBillingPeriods = this.fetchBillingPeriods.bind(this);
  }

  componentWillMount() {
    const now = new Date().toISOString();

    this.props.dataActions.getDataList(
      ACTIVE_BILLING_PERIODS,
      0,
      0,
      "",
      ["startDate:asc"],
      [
        `clientId==${this.props.client.clientId}`,
        `startDate=lt=${now}`,
        `endDate=gt=${now}`,
      ]
    );
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    this.props.dataActions.clearDataList(INVOICES_TABLE);
    this.fetchBillingPeriods();
  }

  componentDidMount() {
    let languageCode = localStorage.getItem("languageCode") || EN.value;
    if (localStorage.getItem("downloadLanguage")) {
      languageCode = localStorage.getItem("downloadLanguage");
    }
    this.setLanguageCode(languageCode);
  }

  componentWillReceivePropsBase(nextProps) {
    // Reload data when clientId changes
    if (nextProps.clientId !== this.props.clientId) {
      const now = new Date().toISOString();
      this.props.dataActions.getDataList(
        ACTIVE_BILLING_PERIODS,
        0,
        0,
        "",
        ["startDate:asc"],
        [
          `clientId==${nextProps.clientId}`,
          `startDate=lt=${now}`,
          `endDate=gt=${now}`,
        ]
      );
      this.props.dataActions.clearDataList(BILLING_PERIODS);
      this.props.dataActions.clearDataList(INVOICES_TABLE);
      this.fetchBillingPeriods();
    }
  }

  componentWillReceiveProps(nextProps) {
    // First, reload data for clientId change if needed
    this.componentWillReceivePropsBase(nextProps);
    const { fileFormat, insurersFetched } = this.props;
    const { invoiceId } = this.state;

    if (
      !!nextProps.items &&
      nextProps.items.length &&
      !_.isEqual(this.props.items, nextProps.items)
      && nextProps.client
    ) {
      
      const latestGeneratedInvoice = nextProps.items.sort((a, b) => {
        if(nextProps.client.clientBillingPeriodType === MANUAL.value) {
          return (
            new Date(b.billingPeriod.startDate) - new Date(a.billingPeriod.startDate)
          );
        }
        return (
          new Date(b.billingPeriod.endDate) - new Date(a.billingPeriod.endDate)
        );
      })[0];
      !!latestGeneratedInvoice &&
        this.setState({
          latestGeneratedPeriod: latestGeneratedInvoice.billingPeriod,
        });
    }
    if (
      fileFormat !== nextProps.fileFormat &&
      nextProps.fileFormat === PREMIUM_BY_INSURER.value
    ) {
      this.props.dataActions.getPagelessDataList(
        INVOICE_DATA,
        0,
        0,
        "",
        ["invoiceDatumId:asc"],
        [`invoiceId==${invoiceId}`],
        null,
        ""
      );
    }
    // trigger validation error if no insurers available
    if (
      nextProps.fileFormat === PREMIUM_BY_INSURER.value &&
      !insurersFetched &&
      nextProps.insurersFetched &&
      !nextProps.insurers.length
    ) {
      this.props.formActions.touch("downloadForm", "insurerId");
      this.props.formActions.focus("downloadForm", "insurerId");
      this.props.formActions.change("downloadForm", "insurerId", null);
      this.props.formActions.blur("downloadForm", "insurerId");
    }
  }

  componentDidUpdate(prevProps) {
    const { invoicesRefresh } = this.props;
    
    if(prevProps.invoicesRefresh !== invoicesRefresh && invoicesRefresh === true) {
      this.refreshDataTable();
      this.props.invoiceActions.setInvoicesRefresh(false);
    }
  }


  fetchBillingPeriods() {
    if (!this.state.fetching) this.setState({ fetching: true });
    const fields = "billingPeriodId,endDate,startDate,localizations,isDelayed,isFinalized";
    const filters = [`billingPeriods.clientId==${this.props.clientId}`];

    this.props.dataActions
      .getDataList(
        BILLING_PERIODS,
        0,
        0,
        "",
        ["startDate:desc"],
        filters,
        {},
        {},
        fields
      )
      .then(() => this.setState({ fetching: false, chosenBillingPeriodFilter:  this.getBillingPeriodFilterDefaultValue()}));
      }

  canDownload(description) {
    /**
     * Function that checks if an identical download is currently in progress.
     */
    if (this.props.currentDownloads.length == 0) {
      return true;
    }

    return !this.props.currentDownloads.some(
      (file) => file.identifier == description
    );
  }
  closeModal() {
    this.setState({ showModal: false });
  }

  updateValidity(validity) {
    this.setState({ isValid: validity });
  }

  onDownloaded(attachment) {
    this.props.dataActions.getDataItem(
      INVOICE_ATTACHMENTS,
      attachment.invoiceAttachmentId
    );
  }

  setPlanAdministratorCSS(additionnalClass, locale) {
    let langStr = !locale
      ? ""
      : "-" + LocaleUtils.extractLangFromLocale(locale);
    let roleStr = userHasAccess(PLAN_ADMINISTRATOR, true) ? "-pa" : "";

    return classNames(additionnalClass + roleStr + langStr);
  }

  invoiceStatusCSS(statusValue) {
    let result = ` status-indicator status-${statusValue
      .toLowerCase()
      .replace(/_/g, "-")}`;

    return result;
  }

  setCellClassNames() {
    return classNames(`status-invoice `);
  }

  getColsForManualClients() {
    return [
      {
        name: (
          <FormattedMessage id="invoices.datatable.columns.billingPeriod" />
        ),
        display: (invoice) => (
          <span className={this.setCellClassNames()}>
            {
              invoice.billingPeriod.localizations[this.props.authLanguageCode]
                .name
            }
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <span
            className={this.setPlanAdministratorCSS(
              "invoice-number-header",
              localStorage.getItem("languageCode")
            )}
          >
            <FormattedMessage id="invoices.datatable.columns.invoiceNumber" />
          </span>
        ),
        display: (invoice) => (
          <span
            className={
              this.setCellClassNames() +
              this.setPlanAdministratorCSS("invoice-number", null)
            }
          >
            {invoice.invoiceNumber}
          </span>
        ),
        widthPct: 12,
      },
      {
        name: (
          <span
            className={this.setPlanAdministratorCSS(
              "invoice-format",
              localStorage.getItem("languageCode")
            )}
          >
            <FormattedMessage id="invoices.datatable.columns.status" />
          </span>
        ),
        display: (invoice) => (
          <span>
            <InvoiceState
              invoice={invoice}
              setCellClassNames={this.setCellClassNames}
              setPlanAdministratorCSS={this.setPlanAdministratorCSS}
              updateValidity={this.updateValidity}
              refreshDataTable={this.refreshDataTable}
              client={this.props.client}
            />
          </span>
        ),
        widthPct: 16,
      },
      {
        name: (
          <FormattedMessage id="invoices.datatable.columns.invoiceType" />
        ),
        display: (invoice) => {
          const invoiceType = invoice.invoiceType;
          return (
            invoiceType === STANDARD_CREDITLESS.value || invoiceType === STANDARD.value  ?
            <FormattedMessage id="invoices.datatable.informations.standardInvoiceType" />  
            : <FormattedMessage id={`invoices.datatable.informations.${invoiceType.toLowerCase()}InvoiceType`} />
          );
        },
        widthPct: 16,
      },
      {
        name: (
          <span className="title-summaryonly-invoice">
            <FormattedMessage id="invoices.datatable.columns.summaryOnly" />
          </span>
        ),
        display: (invoice) => {
          return (
            <div>
              {invoice.invoiceStatusType != GENERATING.value &&
                invoice.invoiceStatusType != FAILURE.value && (
                  <div className="flex-item-size">
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.PDF" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY_ONLY.value,
                          type: PDF.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          SHORT_PDF.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.EXCEL" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY_ONLY.value,
                          type: EXCEL.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          SHORT_EXCEL.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                  </div>
                )}
            </div>
          );
        },
        widthPct: 23,
      },
      {
        name: (
          <span className="amount-format-header">
            <FormattedMessage id="invoices.datatable.columns.amount" />
          </span>
        ),
        display: (invoice) => (
          <span>
            {invoice.invoiceStatusType != GENERATING.value &&
              invoice.invoiceStatusType != FAILURE.value && (
                <span className={this.setCellClassNames() + "amount-format"}>
                  {invoice.amount != null ? (
                    <FormattedNumber
                      value={invoice.amount}
                      style="currency"
                      currency="CAD"
                    />
                  ) : (
                    <span className="nb_format">
                      <FormattedMessage id="common.nd" />
                    </span>
                  )}
                </span>
              )}
          </span>
        ),
        widthPct: 13,
      },
    ];
  }

  getColsForRecurringClients() {
    return [
      {
        name: (
          <FormattedMessage id="invoices.datatable.columns.billingPeriod" />
        ),
        display: (invoice) => (
          <span className={this.setCellClassNames()}>
            {
              invoice.billingPeriod.localizations[this.props.authLanguageCode]
                .name
            }
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <span
            className={this.setPlanAdministratorCSS(
              "invoice-number-header",
              localStorage.getItem("languageCode")
            )}
          >
            <FormattedMessage id="invoices.datatable.columns.invoiceNumber" />
          </span>
        ),
        display: (invoice) => (
          <span
            className={
              this.setCellClassNames() +
              this.setPlanAdministratorCSS("invoice-number", null)
            }
          >
            {invoice.invoiceNumber}
          </span>
        ),
        widthPct: 12,
      },
      {
        name: (
          <span
            className={this.setPlanAdministratorCSS(
              "invoice-format",
              localStorage.getItem("languageCode")
            )}
          >
            <FormattedMessage id="invoices.datatable.columns.status" />
          </span>
        ),
        display: (invoice) => (
          <span>
            <InvoiceState
              invoice={invoice}
              setCellClassNames={this.setCellClassNames}
              setPlanAdministratorCSS={this.setPlanAdministratorCSS}
              updateValidity={this.updateValidity}
              refreshDataTable={this.refreshDataTable}
              client={this.props.client}
            />
          </span>
        ),
        widthPct: 16,
      },
      {
        name: (
          <span className="title-summaryonly-invoice">
            <FormattedMessage id="invoices.datatable.columns.summaryOnly" />
          </span>
        ),
        display: (invoice) => {
          return (
            <div>
              {invoice.invoiceStatusType != GENERATING.value &&
                invoice.invoiceStatusType != FAILURE.value && (
                  <div className="flex-item-size">
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.PDF" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY_ONLY.value,
                          type: PDF.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          SHORT_PDF.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.EXCEL" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY_ONLY.value,
                          type: EXCEL.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          SHORT_EXCEL.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                  </div>
                )}
            </div>
          );
        },
        widthPct: 13,
      },
      {
        name: (
          <FormattedMessage
            id="invoices.datatable.columns.summaryAndListOfParticipants"
            values={{ br: <br /> }}
          />
        ),
        display: (invoice) => {
          return (
            <div>
              {invoice.invoiceStatusType != GENERATING.value &&
                invoice.invoiceStatusType != FAILURE.value && (
                  <div className="flex-item-size-column">
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.PDF" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY.value,
                          type: PDF.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          LONG_PDF.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                  </div>
                )}
            </div>
          );
        },
        widthPct: 13,
      },
      {
        name: (
          <FormattedMessage
            id="invoices.datatable.columns.summaryCostsAndCoverages"
            values={{ br: <br /> }}
          />
        ),
        display: (invoice) => {
          return (
            <div>
              {invoice.invoiceStatusType != GENERATING.value &&
                invoice.invoiceStatusType != FAILURE.value && (
                  <div className="flex-item-size-column">
                    <div className="margin">
                      <FormattedMessage id="invoices.view.types.EXCEL" />
                    </div>
                    <div>
                      <DownloadS3Button
                        model={INVOICE_ATTACHMENTS}
                        refreshDataTable={this.refreshDataTable}
                        invoiceAttachment={{
                          visualizeStatusType:
                            invoice.invoiceVisualizeStatusType,
                          attachments: invoice.invoiceAttachments,
                          format: SUMMARY.value,
                          type: EXCEL.value,
                          language: this.state.languageCode,
                          invoiceId: invoice.invoiceId,
                        }}
                        identifier={this.buildDescription(
                          invoice,
                          SUMMARY_EXCEL.value
                        )}
                        label={""}
                        onDownloaded={this.onDownloaded}
                      />
                    </div>
                  </div>
                )}
            </div>
          );
        },
        widthPct: 13,
      },
      {
        name: (
          <span className="amount-format-header">
            <FormattedMessage id="invoices.datatable.columns.amount" />
          </span>
        ),
        display: (invoice) => (
          <span>
            {invoice.invoiceStatusType != GENERATING.value &&
              invoice.invoiceStatusType != FAILURE.value && (
                <span className={this.setCellClassNames() + "amount-format"}>
                  {invoice.amount != null ? (
                    <FormattedNumber
                      value={invoice.amount}
                      style="currency"
                      currency="CAD"
                    />
                  ) : (
                    <span className="nb_format">
                      <FormattedMessage id="common.nd" />
                    </span>
                  )}
                </span>
              )}
          </span>
        ),
        widthPct: 13,
      },
    ];
  }

  getCols() {
    let cols = [];
    const { client } = this.props;

    if (client) {
      if (client.clientBillingPeriodType === RECURRING.value) {
        return this.getColsForRecurringClients();
      }
      else if(client.clientBillingPeriodType === MANUAL.value) {
        return this.getColsForManualClients();
      }
    }

    return cols;

  }

  refreshDataTable() {
    const { offset, limit, q, sortBy, filters } = this.props;
    this.getData(offset, limit, q, sortBy, filters);
  }

  getData(offset, limit, q, sortBy, filters) {
    this.setState({ isValid: true });
    const additionalFilters = this.props.client.clientBillingPeriodType == RECURRING.value ? [...filters, "distinct==True"] : filters;
    this.props.dataActions.getDataList(
      INVOICES_TABLE,
      offset,
      limit,
      q,
      sortBy,
      additionalFilters,
      null
    );
  }

  getFileFormat(fileFormatKey, translationFile) {
    switch (fileFormatKey) {
      case "SHORT_PDF":
        return translationFile.invoices.view.types.shortPDF;
      case "SHORT_EXCEL":
        return translationFile.invoices.view.types.shortExcel;
      case "LONG_PDF":
        return translationFile.invoices.view.types.longPDF;
      case "SUMMARY_EXCEL":
        return translationFile.invoices.view.types.summaryExcel;
    }
  }

  buildDescription(invoice, fileFormatKey) {
    const userLanguage = localStorage.getItem("languageCode") || EN.value;
    let translationFile;
    let fileFormat;
    let invoiceInfo = invoice.billingPeriod.localizations[userLanguage].name; // When we don't have an invoice number, we can use the billing period name to give more info to the user.
    translationFile = englishTranslations;
    if (userLanguage == "fr-CA") {
      translationFile = frenchTranslations;
    }

    if (invoice.invoiceNumber) {
      invoiceInfo = invoice.invoiceNumber; // If invoice has a number, then we can use the invoiceNumber as an identifier.
    }

    fileFormat = this.getFileFormat(fileFormatKey, translationFile);
    return (
      translationFile.downloader.invoiceDownload +
      ": " +
      this.props.client.name +
      " - " +
      invoiceInfo +
      ", " +
      fileFormat
    );
  }

  monthMinusX(date, x) {
    return moment(date).subtract(x, "month").format("YYYY-MM-DD");
  }

  getBillingPeriodFilterDefaultValue() {
    if(this.props.billingPeriods && this.props.billingPeriods.length > 0) {
      this.props.changeFieldValue("BillingPeriod", "billingPeriodId", this.props.billingPeriods[0].billingPeriodId);
      return this.props.billingPeriods[0];
    }
  }

  updateBillingPeriodFilter(event) {
    if (event.target) {
      const billingPeriodId = event.target.value;
      let filters = [];
      const billingPeriod = this.props.billingPeriods.find(
        (period) => period.billingPeriodId == billingPeriodId
      );
      let startDate = this.monthMinusX(
        billingPeriod.startDate,
        this.state.limitInvoiceDisplayed
      );
      if (userHasAccess(PLAN_ADMINISTRATOR, true)) {
        filters.push(INVOICE_DATA.finalStatusType);
      }
      filters.push(`billingPeriods.clientId==${this.props.clientId}`);
      filters.push(INVOICE_DATA.canceledFilter);
      filters.push(`billingPeriods.startDate>${startDate}`);
      filters.push(`billingPeriods.startDate<=${billingPeriod.startDate}`);
      this.setState({ filters: filters, chosenBillingPeriodFilter: billingPeriod });
      this.getData(this.props.offset, this.state.limitInvoiceDisplayed, this.props.q, this.props.sortBy, filters);
    }
  }

  setLanguageCode(languageCode) {
    this.setState({ languageCode: languageCode });
  }

  handleCloseForm() {
    this.props.dataActions.clearDataList(INVOICE_DATA);
    this.setState({ invoiceId: null });
  }

  render() {
    const { activeBillingPeriods, activeInvoice, billingPeriods, items } = this.props;
    const { fetching, isValid } = this.state;
    const dataTableClassNames = classNames({
      datatable: true,
      "show-overflow": true,
      "invoices-datatable": true,
    });
    return (
      <div>
        {!fetching && (
          <div>
            {activeBillingPeriods &&
            activeInvoice &&
            activeBillingPeriods.length > 0 ? (
              <div className={dataTableClassNames}>
                <div>
                  <InvoiceDataTableHeader
                    languageCode={this.setLanguageCode}
                    billingPeriods={billingPeriods}
                    activeBillingPeriods={activeBillingPeriods}
                    updateBillingPeriodFilter={this.updateBillingPeriodFilter}
                    clientId={this.props.clientId}
                    client={this.props.client}
                    activeInvoice={activeInvoice}
                    authLanguageCode={this.props.authLanguageCode}
                    limit={this.props.limit}
                    offset={this.props.offset}
                    q={this.props.q}
                    sortBy={this.props.sortBy}
                    filters={this.props.filters}
                    isValid={isValid}
                    updateValidity={this.updateValidity}
                    invoices={items}
                    chosenBillingPeriodFilter={this.state.chosenBillingPeriodFilter}
                    fetchBillingPeriods={this.fetchBillingPeriods}
                  />
                </div>
                <DataTable
                  ref="dataTable"
                  title={<FormattedMessage id="invoices.title" />}
                  getData={this.getData}
                  cols={this.getCols()}
                  q={this.props.q}
                  filters={this.props.filters}
                  offset={this.props.offset}
                  data={this.props.items}
                  rowsPerPage={this.state.limitInvoiceDisplayed}
                  totalRows={this.state.limitInvoiceDisplayed}
                  sortBy={this.props.sortBy}
                  showFilters={false}
                />
                {renderErrorModal(
                  this.state.showModal,
                  this.closeModal,
                  this.state.errorsString,
                  "validation.clientFieldValidation.invoiceMEVError"
                )}
              </div>
            ) : (
              <div className={dataTableClassNames}>
                <MessageBox className="alert-warning bg-transparent">
                  <FormattedMessage id="invoices.datatable.actions.noBillingPeriods" />
                </MessageBox>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

InvoicesDataTable.propTypes = {
  authLanguageCode: PropTypes.string.isRequired,
  billingPeriods: PropTypes.array,
  client: PropTypes.object,
  dataActions: PropTypes.object,
  invoiceActions: PropTypes.object,
  fileFormat: PropTypes.string,
  filters: PropTypes.array,
  formActions: PropTypes.object,
  insuranceTypes: PropTypes.array,
  insurers: PropTypes.array,
  insurersFetched: PropTypes.bool,
  items: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  q: PropTypes.string,
  sortBy: PropTypes.array,
  statuses: PropTypes.array,
  total: PropTypes.number,
  activeBillingPeriods: PropTypes.array,
  currentDownloads: PropTypes.array,
  changeFieldValue: PropTypes.func,
  fetched: PropTypes.bool,
  activeInvoice: PropTypes.array,
  clientId: PropTypes.number,
  invoicesRefresh: PropTypes.bool
};

function mapStateToProps(state) {
  const billingPeriods = state.data.billingPeriods || {};
  const data = state.data.invoiceDataFront || {};
  const pagination = data.pagination || {};
  const clients = state.data.clients || {};
  const client = clients.active || {};
  const insurers = state.data.invoiceData || {};
  const activeBillingPeriods = billingPeriods.items;
  const activeInvoice = data || {};
  const downloads = state.downloader;
  const invoicesRefresh = state.invoicesRefresh;
  let invoiceDataFront = data.items ? [...data.items] : [];

  if (client.businessAccountType === PM.value && client.clientBillingPeriodType === MANUAL.value) {
    invoiceDataFront.forEach(item => {
      if (item.invoiceType === CREDITS.value) {
        const englishAdjustment = englishTranslations.invoices.view.invoiceTypes.credits;
        const frenchAdjustment = frenchTranslations.invoices.view.invoiceTypes.credits;
        !item.billingPeriod.localizations[EN.value].name.includes(englishAdjustment) && (item.billingPeriod.localizations[EN.value].name += `-${englishTranslations.invoices.view.invoiceTypes.credits}`);
        !item.billingPeriod.localizations[FR.value].name.includes(frenchAdjustment) && (item.billingPeriod.localizations[FR.value].name += `-${frenchTranslations.invoices.view.invoiceTypes.credits}`);
      }
    });
  }
  let filters = [
    `billingPeriods.clientId==${client.clientId}`,
    INVOICE_DATA.canceledFilter,
  ];
  if (userHasAccess(PLAN_ADMINISTRATOR, true)) {
    filters.push(INVOICE_DATA.finalStatusType);
  }
  const limitInvoiceDisplayed = client.clientBillingPeriodType == MANUAL.value ? LIMIT_INVOICES_DISPLAYED_MANUAL : LIMIT_INVOICES_DISPLAYED;
  const selector = formValueSelector("downloadForm");

  return {
    activeBillingPeriods: activeBillingPeriods || [],
    authLanguageCode: state.auth.user.languageCode,
    billingPeriods: billingPeriods.items || [],
    client,
    clientId: state.data.clients.active.clientId,
    fileFormat: selector(state, "fileFormat"),
    filters: filters,
    insurers: insurers.items || [],
    insurersFetched: !!insurers.fetched,
    items: invoiceDataFront || [],
    activeInvoice: activeInvoice.items || [],
    limit: pagination.limit || limitInvoiceDisplayed,
    offset: pagination.offset || 0,
    currentDownloads: downloads.files || [],
    q: data.q,
    sortBy: data.sortBy || ["billingPeriodId:desc", "invoiceId:desc"],
    total: pagination.totalCount || 0,
    invoicesRefresh
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
    formActions: bindActionCreators(actions, dispatch),
    invoiceActions: bindActionCreators(invoiceActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/InvoicesDataTable.js